var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-calendar-and-time-4641728",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14268",
    "data-name": "Group 14268",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13390",
    "data-name": "Path 13390",
    d: "M15.4,2.067H13.8V1.533a.533.533,0,1,0-1.067,0v.533H5.267V1.533a.533.533,0,1,0-1.067,0v.533H2.6A1.6,1.6,0,0,0,1,3.667V15.4A1.6,1.6,0,0,0,2.6,17H8.205a.533.533,0,0,0,0-1.067H2.6a.534.534,0,0,1-.533-.533V6.333H15.933V8.205a.533.533,0,0,0,1.067,0V3.667A1.6,1.6,0,0,0,15.4,2.067ZM2.067,5.267v-1.6A.534.534,0,0,1,2.6,3.133H4.2a.533.533,0,1,0,1.067,0h7.467a.533.533,0,1,0,1.067,0h1.6a.534.534,0,0,1,.533.533v1.6ZM5.8,8.467A.533.533,0,0,1,5.267,9H4.2a.533.533,0,1,1,0-1.067H5.267A.533.533,0,0,1,5.8,8.467ZM9,9H8.467a.533.533,0,0,1,0-1.067H9A.533.533,0,1,1,9,9ZM5.8,11.133a.533.533,0,0,1-.533.533H4.2a.533.533,0,1,1,0-1.067H5.267A.533.533,0,0,1,5.8,11.133Zm0,2.667a.533.533,0,0,1-.533.533H4.2a.533.533,0,1,1,0-1.067H5.267A.533.533,0,0,1,5.8,13.8Zm6.933-5.333A4.267,4.267,0,1,0,17,12.733,4.272,4.272,0,0,0,12.733,8.467Zm0,7.467a3.2,3.2,0,1,1,3.2-3.2A3.2,3.2,0,0,1,12.733,15.933Zm1.444-2.51a.533.533,0,1,1-.754.754L12.356,13.11a.534.534,0,0,1-.156-.377V10.6a.533.533,0,1,1,1.067,0v1.913Z",
    transform: "translate(-1 -1)",
    fill: "#868a97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTime);
export default __webpack_public_path__ + "static/media/calendarTime.a01871fd0516a667fbc9be1f2114bd6a.svg";
export { ForwardRef as ReactComponent };